import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IPermission } from '../interfaces/DB/i-permission';
import { SidenavMenu } from '../interfaces/UI/i-menu';
import { AuthService } from '../services/api/auth.service';
import { AlertService } from '../services/local/alert.service';
import { LocalStorageService } from '../services/local/local-storage.service';
import { MenuService } from '../services/local/menu.service';


@Injectable({
  providedIn: 'root'
})
export class VerfiyPermGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private menuService: MenuService,
    private alertService: AlertService,
    public router: Router
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot)
  {
    return this.havePermission(state.url);

  }

  havePermission(url : string){
    return this.menuService.getMenu().pipe(
      map(data =>{
        let perm = this.findPermission(data, url.substring(1));
        let haverPerm = this.authService.checkPerm(perm)

        if (!haverPerm) {
          this.router.navigate(['']);
          this.alertService.SimpleErrorAlert('Acceso denegado', 'Lamentablemente no tienes el permiso para acceder. Si consideras que es un error comunicate con el administrador.')
        }

        return haverPerm;

      })
    )
  }

  public checkPerm(permToCheck: string): boolean {
    const perms = this.authService.GetPermissions()
    if (perms && perms.length && permToCheck.length > 0) {
      return perms.some((perm: IPermission) => perm.Name === permToCheck);
    } else if (permToCheck.length == 0) {
      return true;
    }
    return false;
  }

  findPermission(menu: SidenavMenu[], url: string) {
    let found = '';
    menu.forEach((menuElement) => {
      if (menuElement.url ===  url)  found = menuElement.perm
      if (menuElement.submenu.length > 0) {
        menuElement.submenu.forEach((submenuElement) => {
          if (submenuElement.url ===  url) found = submenuElement.perm
        });
      }
    });
    return found;
  }


}
